import React, { useState } from 'react'
import { getImages } from '../Const';
import CustomerWeekCalender from '../Calendar/CustomerWeekCalender';

const CallBackClientsCalender = ({ leadLocation, leadAction, leadData }) => {

    let csLocation = "pompano-beach";

    switch(leadLocation) {
        case "POMPANO BEACH": csLocation = "pompano-beach"; break;
        case "BOYNTON BEACH": csLocation = "boynton"; break;
        case "POMPANO BEACH": csLocation = "kbb"; break;
    }

    return (
        <>
            <div className="callback-calendar-block">
                <div className='d-lg-none'>
                    <button className='mob-back-btn' type='button'><span><img src={getImages('left-arrow.svg')} /></span> Back</button>
                </div>
                <div className='d-flex align-items-center justify-content-between weekly-sleect-flex'>
                    <div className="d-flex align-items-center justify-content-between">
                        <div className="d-lg-none text-end">
                            <button type="button" className="blue-transparent-btn text-uppercase filter-btn"><img src={getImages('filter-icon.svg')} /> Filters</button>
                        </div>
                    </div>
                    <div className={`d-inline-flex align-items-center list_filter`}>
                        <div className='total-appoint'>Total <span>{leadData ? leadData.length : 0}</span> Appointments</div>
                        {/* <div className='d-flex align-items-center filter-col'>
                            <label>View</label>
                            <select defaultValue={activeCalender} onChange={(e) => setActiveCalender(e.target.value)} className="form-control">
                                <option value="monthly">Monthly</option>
                                <option value="weekly">Weekly</option>
                            </select>
                        </div> */}
                    </div>
                </div>

                <CustomerWeekCalender
                    leadData={leadData}
                    leadAction={leadAction}
                    csLocation={csLocation}
                />
            </div>
        </>
    )
}

export default CallBackClientsCalender